// extracted by mini-css-extract-plugin
module.exports = {"FAQ_section":"FAQs_FAQ_section__iaMny","addLink":"FAQs_addLink__2w-13","conversationText":"FAQs_conversationText__3gpAt","inputTextare":"FAQs_inputTextare__1U3DC"};